var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bottomHide == false ? false : true)?_c('div',{staticClass:"end"},[_c('div',{staticClass:"content"},[_c('a',{on:{"click":_vm.privacyClick}},[_vm._v("Privacy")]),_c('a',{on:{"click":_vm.contactClick}},[_vm._v("Contact us")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }